import { render } from "./SectionDivisor.vue?vue&type=template&id=2f2e17d5&scoped=true&ts=true"
import script from "./SectionDivisor.vue?vue&type=script&lang=ts"
export * from "./SectionDivisor.vue?vue&type=script&lang=ts"

import "./SectionDivisor.vue?vue&type=style&index=0&id=2f2e17d5&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f2e17d5"]])

export default __exports__